
import Vue from 'vue';

export default Vue.extend({
    name: 'GlobalLoading',
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: null,
        },
    },
})
